import { render, staticRenderFns } from "./gentangendis.vue?vue&type=template&id=c7e12a38"
import script from "./gentangendis.vue?vue&type=script&lang=js"
export * from "./gentangendis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports